import { createBrowserHistory } from 'history';

import getUserConfirmation from './components/LeaveHook/getUserConfirmation';

export default createBrowserHistory({
	getUserConfirmation,
});
